module.exports = __webpack_public_path__ + "media/images/icons/order-5cc31624cb63f0d27474d50f987bdc50.svg";